import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetScrollContainer } from './useGetScrollContainer'
import { ScrollContainerContent } from './ScrollContainerContent'

export const ScrollContainerComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetScrollContainer(id, tileFilterSelections)

  return (
    <ScrollContainerContent
      containerId={id}
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ScrollContainerComponentLoading() {
  return 'Loading...'
}
